import React from 'react'
import { TitledPaper } from '@dai/components'
import * as Yup from 'yup'
import { ActionCodeInfo } from 'firebase/auth'
import HandleResetPassword from './HandleResetPassword'
import SendResetPasswordEmail, {
  PasswordResetFormLabels,
} from './SendResetPasswordEmail'

export type PasswordResetLabels = {
  title: string
  subtitle: string
} & PasswordResetFormLabels

interface ResetPasswordProps {
  oobCode: string | null
  signInUrl: string
  signUpUrl: string
  passwordSchema: Yup.StringSchema
  checkActionCode: (code: string) => Promise<ActionCodeInfo>
  confirmPasswordReset: (oobCode: string, password: string) => Promise<void>
  sendPasswordResetEmail: (
    email: string,
    continueUrl?: string | undefined,
  ) => Promise<void>
  labels?: PasswordResetLabels
}

const defaultFormLabels: PasswordResetFormLabels = {
  mustBeValidEmail: 'Must be a valid email',
  emailRequired: 'Email is required',
  email: 'Email Address',
  resetPasswordButton: 'Reset password',
  emailSentConfirmationMessage: (email: string) =>
    `Password reset email sent to ${email}.`,
  defaultErrorMessage: 'Something went wrong',
  dontHaveAnAccount: "Don't have an account?",
  signUpButton: 'Sign up',
}

const ResetPassword: React.FC<ResetPasswordProps> = ({
  oobCode,
  signUpUrl,
  signInUrl,
  passwordSchema,
  checkActionCode,
  confirmPasswordReset,
  sendPasswordResetEmail,
  labels = {
    ...defaultFormLabels,
    title: 'Reset Password',
    subtitle: 'Enter your email to reset your password',
  },
}) => {
  return oobCode ? (
    <HandleResetPassword
      oobCode={oobCode}
      signInUrl={signInUrl}
      passwordSchema={passwordSchema}
      checkActionCode={checkActionCode}
      confirmPasswordReset={confirmPasswordReset}
    />
  ) : (
    <TitledPaper title={labels.title} subtitle={labels.subtitle}>
      <SendResetPasswordEmail
        signUpUrl={signUpUrl}
        sendPasswordResetEmail={sendPasswordResetEmail}
        labels={labels}
      />
    </TitledPaper>
  )
}

export default ResetPassword
